<template>
    <b-form-row>
        <b-modal :id="this.id" ref="finder" size="xl" button-size="sm" hide-footer :title="prefix + title"
            @hidden="cancelar" @close="cancelar">
            <LoteList :prefix="prefix"  @onselect="loteSelect" :produto="produto" :almoxarifado="almoxarifado" />
        </b-modal>

        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" label="Lote:"
            invalidFeedback="Lote deve ser informado!" description="" @handleClean="loteSelect" :disabled="disabled"
            :showClearButton="!isDisabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed :disabled="disabled" v-if="!isDisabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import LoteList from "../../modules/cadastros/lote/LoteList.vue"

export default {
    components: { LgFormInputFinder, LoteList },

    props: {
        isDisabled: { Boolean, default: false },
        disabled: { Boolean, default: false },
        id: String,
        onselect: Function,
        user: Object,
        value: Object,
        almoxarifado: Object,
        produto: Object,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Lote",
        },
        label: {
            type: String,
            default: "Lote:",
        },
    },

    data() {
        return {
            descricao: "",
            localValue: this.value,
        }
    },

    watch: {
        value(newValue) {
            this.localValue = newValue
        },

        localValues(newValue) {
            this.$emit("input", newValue)
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show()
            this.$bvModal.show(this.id)
        },

        async loteSelect(lote) {
            this.localValue = lote
            this.$emit("input", lote)
            this.$refs.finder.hide()
        },

        cancelar() {
            this.$emit("close")
        },
    },
}
</script>
